module.exports = __webpack_public_path__ + "static/findevr-sf-2015-735269786189fc0b8e270a1c312604ec.png";